module.exports = __webpack_public_path__ + "static/2-8439cf22d73679f3a242c45cce9c41e4.jpg";